module.exports = __webpack_public_path__ + "static/mobEmployeeManagement-bdbe395e6b8c728b04897570ce062560.png";